export default "__VITE_ASSET__90435e7f__"